export default __webpack_public_path__ + "static/media/title.0f17436c.svg";